<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Actualizar Credenciales Veraz">
          <b-form>
            <b-form-group
              label="Matriz"
              label-for="matriz"
              :label-cols="labelCols">
              <b-form-input 
                id="matriz"
                v-model.trim="$v.matriz.$model" 
                :state="matrizValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="matrizFeedback">
                {{ matrizInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Sector"
              label-for="sector"
              :label-cols="labelCols">
              <b-form-input 
                id="sector"
                v-model.trim="$v.sector.$model" 
                :state="sectorValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="sectorFeedback">
                {{ sectorInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Sucursal"
              label-for="sucursal"
              :label-cols="labelCols">
              <b-form-input 
                id="sucursal"
                v-model.trim="$v.sucursal.$model" 
                :state="sucursalValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="sucursalFeedback">
                {{ sucursalInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Usuario"
              label-for="usuario"
              :label-cols="labelCols">
              <b-form-input 
                id="usuario"
                v-model.trim="$v.usuario.$model" 
                :state="usuarioValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="usuarioFeedback">
                {{ usuarioInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Clave"
              label-for="clave"
              :label-cols="labelCols">
              <b-form-input 
                id="clave"
                v-model.trim="$v.clave.$model" 
                :state="claveValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="claveFeedback">
                {{ claveInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <div class="fixed-btn">
      <div class="abm-save-btn" 
          @click.prevent="save">
        <i class="fa fa-save fa-2x" aria-hidden="true"></i>
      </div>
      <div class="abm-cancel-btn" 
          @click.prevent="goInicio">
        <i class="fa fa-close fa-2x" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { required, maxLength } from 'vuelidate/lib/validators';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'usuarioVeraz/getField',
  mutationType: 'usuarioVeraz/updateField',
});

export default {
  name: 'UsuarioVeraz',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      matrizValida: null,
      matrizInvalidaMsj: '',
      sectorValido: null,
      sectorInvalidoMsj: '',
      sucursalValida: null,
      sucursalInvalidaMsj: '',
      usuarioValido: null,
      usuarioInvalidoMsj: '',
      claveValida: null,
      claveInvalidaMsj: '',

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'matriz',
      'sector',
      'sucursal',
      'usuario',
      'clave'
    ]),
  },  
  created() {
    this.showSpinner();
    this.$store.dispatch('usuarioVeraz/getUsuarioVeraz')
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "matriz" || validarTodos) {
        if (this.$v.matriz.$error) {
          this.matrizValida = false;
          if (!this.$v.matriz.required) {
            this.matrizInvalidaMsj = 'Debe ingresar la matriz correspondiente.';
          } else if (!this.$v.matriz.maxLength) {
            this.matrizInvalidaMsj = 'La matriz sólo puede contener hasta 50 caracteres.';
          }
        } else {
          this.matrizValida = null;
          this.matrizInvalidaMsj = '';
        }
      }
      if (campo == "sector" || validarTodos) {
        if (this.$v.sector.$error) {
          this.sectorValido = false;
          if (!this.$v.sector.required) {
            this.sectorInvalidoMsj = 'Debe ingresar el sector correspondiente.';
          } else if (!this.$v.sector.maxLength) {
            this.sectorInvalidoMsj = 'El sector sólo puede contener hasta 50 caracteres.';
          }
        } else {
          this.sectorValido = null;
          this.sectorInvalidoMsj = '';
        }
      }
      if (campo == "sucursal" || validarTodos) {
        if (this.$v.sucursal.$error) {
          this.sucursalValida = false;
          if (!this.$v.sucursal.required) {
            this.sucursalInvalidaMsj = 'Debe ingresar la sucursal correspondiente.';
          } else if (!this.$v.matriz.maxLength) {
            this.sucursalInvalidaMsj = 'La sucursal sólo puede contener hasta 50 caracteres.';
          }
        } else {
          this.sucursalValida = null;
          this.sucursalInvalidaMsj = '';
        }
      }
      if (campo == "usuario" || validarTodos) {
        if (this.$v.usuario.$error) {
          this.usuarioValido = false;
          if (!this.$v.usuario.required) {
            this.usuarioInvalidoMsj = 'Debe ingresar el usuario correspondiente.';
          } else if (!this.$v.usuario.maxLength) {
            this.usuarioInvalidoMsj = 'El usuario sólo puede contener hasta 50 caracteres.';
          }
        } else {
          this.usuarioValido = null;
          this.usuarioInvalidoMsj = '';
        }
      }
      if (campo == "clave" || validarTodos) {
        if (this.$v.clave.$error) {
          this.claveValida = false;
          if (!this.$v.clave.required) {
            this.claveInvalidaMsj = 'Debe ingresar la clave correspondiente.';
          } else if (!this.$v.clave.maxLength) {
            this.claveInvalidaMsj = 'La clave sólo puede contener hasta 255 caracteres.';
          }
        } else {
          this.claveValida = null;
          this.claveInvalidaMsj = '';
        }
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
          this.showSpinner();
          this.$store.dispatch('usuarioVeraz/save')
            .then(()  => this.showModalMsj('Las credenciales se actualizaron con éxito.', this.goInicio, this.goInicio, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
      }
    },
    goInicio() {
      this.$router.push({ name: 'Dashboard' });
    },
  },
  validations: {
    matriz: {
      required,
      maxLength: maxLength(50)
    },
    sector: {
      required,
      maxLength: maxLength(50)
    },
    sucursal: {
      required,
      maxLength: maxLength(50)
    },
    usuario: {
      required,
      maxLength: maxLength(50)
    },
    clave: {
      required,
      maxLength: maxLength(255)
    },
  },  
}
</script>

<style>
</style>
